import { useEffect } from "react";

export function useClickOutside(ref: React.RefObject<HTMLElement | null>, handler: EventListener) {
  useEffect(() => {
    const listener = (event: Event) => {
      // Skip if ref is not set or click is inside the element
      if (!ref.current || ref.current.contains(event.target as Node)) return;
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
